import PropTypes from 'prop-types'
import styled from 'styled-components'
import React, { Component } from 'react'
import { Button, Popconfirm, Tabs, Icon, Collapse, Pagination } from 'antd'
import CreateCompanyContactForm from '../../components/CreateCompanyContactForm'
import SelectExistingContact from '../../components/SelectExistingContact'
import history from '../../history'
import { drop } from 'lodash'

const { Panel } = Collapse

const TabPane = Tabs.TabPane

const StyledTabs = styled(Tabs)`
  padding: 15px;
  background-color: #f7f7f7;
`
const propTypes = {
  primaryContactId: PropTypes.number
}
class ContactsQuickAdd extends Component {
  constructor(props) {
    super(props)
    this.state = {
      contactFormShowing: false,
      contactData: null,
      page: 1
    }
  }

  setPage = page => {
    this.setState({
      page
    })
  }

  handleCreateContactButton = contactData => {
    this.setState({
      contactFormShowing: false
    })
    this.props.handleCreateContactButton(contactData)
  }

  handleCreateContactByIdButton = contactId => {
    this.setState({
      contactFormShowing: false
    })
    this.props.handleCreateContactByIdButton(contactId)
  }

  handleUpdateContactButton = contactData => {
    this.setState({
      contactFormShowing: false
    })
    this.props.handleUpdateContactButton(contactData)
  }

  handleAddContactButton = () => {
    this.setState({
      contactFormShowing: true
    })
  }

  handleCancelContactButton = () => {
    this.setState({
      contactFormShowing: false
    })
  }

  handleContactShortcut = row => {
    history.push(`/contacts/${row.id}`)
  }

  renderElement = data => {
    const { id, title, first_name, last_name, is_primary_contact } = data
    const name = `${first_name} ${last_name}`
    return (
      <Panel key={id} header={name}>
        <div className="row">
          <div className="col-md-2">
            <div className="jobDetailsHeader">ID:</div>
            <span>{id}</span>
          </div>
          <div className="col-md-2">
            <div className="jobDetailsHeader">Name:</div>
            <span>{name}</span>
          </div>
          <div className="col-md-2">
            <div className="jobDetailsHeader">Title:</div>
            <span>{title}</span>
          </div>
          <div className="col-md-6">
            <Popconfirm
              title="Are you sure you want to make this the primary contact for this company?"
              onConfirm={() => this.props.handleMakePrimaryContact(id)}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              <Button size="small" type="link" style={{ color: '#1F45B4' }}>
                <Icon type="star" theme={is_primary_contact ? 'filled' : 'outlined'} />
              </Button>
            </Popconfirm>
            <Button
              size="small"
              icon="export"
              onClick={() => this.handleContactShortcut(data)}
              className="marginLeft5"
            />
            <Popconfirm
              title="Are you sure you want to delete this line?"
              onConfirm={() => this.props.handleDeleteContact(id)}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              <Button size="small" className="marginLeft5" type="danger" icon="delete" />
            </Popconfirm>
          </div>
        </div>
      </Panel>
    )
  }

  getPagedData = () => {
    const { page } = this.state
    const data = this.props.companyContacts || []
    const offset = (page - 1) * 5
    return drop(data, offset).slice(0, 5)
  }

  render() {
    const companyContacts = this.props.companyContacts || []
    return (
      <div className="">
        <div className="jobsBar">
          Contacts
          {!this.state.contactFormShowing && (
            <div className="jobsBarAdd" onClick={() => this.handleAddContactButton()}>
              <i className="fa fa-pencil-square" aria-hidden="true" />
              &nbsp;<div className="addJobLabel">ADD CONTACT</div>
            </div>
          )}
          {this.state.contactFormShowing && (
            <div className="displayFlex">
              <div className="jobsBarAdd" onClick={() => this.handleCancelContactButton()}>
                <i className="fa fa-ban" aria-hidden="true" />
                &nbsp;<div className="addJobLabel">CANCEL</div>
              </div>
            </div>
          )}
        </div>
        {this.state.contactFormShowing && (
          <StyledTabs defaultActiveKey="1">
            <TabPane tab="Search existing contact" key="1">
              <SelectExistingContact
                allContacts={this.props.allContacts}
                addContact={this.handleCreateContactByIdButton}
              />
            </TabPane>
            <TabPane tab="Add new Contact" key="2">
              <CreateCompanyContactForm
                addContact={this.handleCreateContactButton}
                saveContact={this.handleUpdateContactButton}
                contentData={this.state.contactData}
              />
            </TabPane>
          </StyledTabs>
        )}
        <Collapse>{this.getPagedData().map(this.renderElement)}</Collapse>
        <Pagination
          total={companyContacts.length}
          pageSize={5}
          defaultCurrent={1}
          onChange={this.setPage}
          current={this.state.page}
          hideOnSinglePage
        />
      </div>
    )
  }
}
ContactsQuickAdd.propTypes = propTypes
export default ContactsQuickAdd



// WEBPACK FOOTER //
// ./src/containers/companies/ContactsQuickAdd.js